export enum RelationType {
  // Infrastructure and Hosting
  RUNS_ON = 'RUNS_ON',
  DEPENDS_ON = 'DEPENDS_ON',
  HOSTED_BY = 'HOSTED_BY',
  USES_INFRASTRUCTURE = 'USES_INFRASTRUCTURE',

  // Service relationships
  PROVIDES_SERVICE = 'PROVIDES_SERVICE',
  CONSUMED_BY = 'CONSUMED_BY',
  PART_OF_SERVICE = 'PART_OF_SERVICE',

  // Data and Storage
  READS_FROM = 'READS_FROM',
  WRITES_TO = 'WRITES_TO',
  STORES_DATA_IN = 'STORES_DATA_IN',
  BACKED_UP_BY = 'BACKED_UP_BY',
  REPLICATES_TO = 'REPLICATES_TO',

  // Network and Security
  IN_ZONE = 'IN_ZONE',
  IN_SECURITY_ZONE = 'IN_SECURITY_ZONE',
  USES_NETWORK = 'USES_NETWORK',
  CONNECTS_TO = 'CONNECTS_TO',
  PROTECTED_BY = 'PROTECTED_BY',
  ISOLATED_FROM = 'ISOLATED_FROM',
  EXPOSES_SERVICE = 'EXPOSES_SERVICE',

  // Authentication and Secrets
  USES_SECRET = 'USES_SECRET',
  USES_CERTIFICATE = 'USES_CERTIFICATE',
  USES_CONFIG = 'USES_CONFIG',
  USES_IDP = 'USES_IDP',
  REQUIRES_AUTH = 'REQUIRES_AUTH',
  AUTHENTICATES_WITH = 'AUTHENTICATES_WITH',
  PROVIDES_AUTHENTICATION = 'PROVIDES_AUTHENTICATION',

  // Monitoring and Operations
  LOGS_TO = 'LOGS_TO',
  MONITORED_BY = 'MONITORED_BY',
  ALERTS_TO = 'ALERTS_TO',

  // Ownership and Responsibility
  OWNED_BY = 'OWNED_BY',
  MAINTAINED_BY = 'MAINTAINED_BY',
  RESPONSIBLE_FOR = 'RESPONSIBLE_FOR',

  // Risk and Security
  HAS_RISK = 'HAS_RISK',
  MITIGATED_BY = 'MITIGATED_BY',
  THREAT = 'THREAT',
  EXPLOITS = 'EXPLOITS',
  IMPLEMENTS_CONTROL = 'IMPLEMENTS_CONTROL',
  PROTECTS = 'PROTECTS',
  HAS_CONTROL_GAP = 'HAS_CONTROL_GAP',
  RESOLVED_BY = 'RESOLVED_BY',

  // Documentation
  DOCUMENTED_BY = 'DOCUMENTED_BY',
  FOLLOWS_PROCESS = 'FOLLOWS_PROCESS',
  HAS_PROCEDURE = 'HAS_PROCEDURE',

  // Integration and Data Flow
  SENDS_DATA_TO = 'SENDS_DATA_TO',
  RECEIVES_DATA_FROM = 'RECEIVES_DATA_FROM',
  PUBLISHES_EVENT = 'PUBLISHES_EVENT',
  SUBSCRIBES_TO = 'SUBSCRIBES_TO',
  CALLS_API = 'CALLS_API',

  // Platform Relationships
  PART_OF_PLATFORM = 'PART_OF_PLATFORM',
  USES_PLATFORM = 'USES_PLATFORM',
  DEPLOYED_ON = 'DEPLOYED_ON',

  // DNS and Networking
  RESOLVES_VIA = 'RESOLVES_VIA',

  // CI/CD and Container Registry
  DEPLOYS_TO = 'DEPLOYS_TO',
  PULLS_FROM = 'PULLS_FROM',
  PUSHES_TO = 'PUSHES_TO',
}

export enum CriticalityLevel {
  CRITICAL = 'critical',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export interface Relation {
  id: string;
  type: RelationType;
  fromEntityId: string;
  toEntityId: string;
  description?: string;
  criticality?: CriticalityLevel;
  protocol?: string;
  port?: number;
  isEncrypted?: boolean;
  createdByUserId: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateRelationDto {
  fromEntityId: string;
  toEntityId: string;
  type: RelationType;
  description?: string;
  criticality?: CriticalityLevel;
  protocol?: string;
  port?: number;
  isEncrypted?: boolean;
}

export interface UpdateRelationDto {
  description?: string;
  criticality?: CriticalityLevel;
  protocol?: string;
  port?: number;
  isEncrypted?: boolean;
}
